import React from "react";
import { motion } from "framer-motion";
import { FadeUp } from "@/components/motion";

const EASE = [0.16, 1, 0.3, 1];

const PageMasthead = ({ kicker, titleLines, standfirst, dark = false, compact = false }) => (
  <section className={`${compact ? "" : "pt-[76px]"} ${dark ? "bg-ink text-white" : "bg-background"}`}>
    <div className={`mx-auto max-w-[1400px] px-5 md:px-8 ${compact ? "pt-8 md:pt-10" : "pt-16 md:pt-24"} pb-12 md:pb-16`}>
      <p className="kicker mb-6">{kicker}</p>
      <h1 className={`headline-xl uppercase text-5xl md:text-7xl lg:text-8xl ${dark ? "text-white" : "text-ink"}`}>
        {titleLines.map((l, i) => (
          <motion.span
            key={i}
            className={`block ${l.accent ? "text-primary" : ""}`}
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.08 + i * 0.12 }}
          >
            {l.text}
          </motion.span>
        ))}
      </h1>
      {standfirst && (
        <FadeUp delay={0.25}>
          <p className={`mt-8 max-w-3xl text-lg md:text-2xl font-medium leading-snug ${dark ? "text-white/75" : "text-foreground/75"}`}>
            {standfirst}
          </p>
        </FadeUp>
      )}
    </div>
  </section>
);

export default PageMasthead;
